export enum SSREvent {
	CLICK = 'click',
	HOVER = 'hover',
	FOCUS = 'focus',
}
